import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { Invest } from "../components/Invest/Invest";
import { Safearea } from "../components/UI/Safearea/Safearea";
import { Header } from "../components/Layout/Header/Header";

export const InvestPage = () => {
  return (
    <Fragment>
      <Header title="Invertir" />
      <Safearea>
        <Invest />
      </Safearea>
    </Fragment>
  );
};
